import { render, staticRenderFns } from "./CompaniesBranches.vue?vue&type=template&id=028d812e&scoped=true&"
import script from "./CompaniesBranches.vue?vue&type=script&lang=js&"
export * from "./CompaniesBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028d812e",
  null
  
)

export default component.exports